import { render, staticRenderFns } from "./showRobStructure.vue?vue&type=template&id=11828421&scoped=true"
import script from "./showRobStructure.vue?vue&type=script&lang=js"
export * from "./showRobStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11828421",
  null
  
)

export default component.exports